// Storefront customer account API. Tokens are kept per store, separate from the vendor login, so a store owner can browse
// their own storefront as a shopper without the two sessions touching.
import axios from "axios";
import { API } from "@/lib/api";

export const tokenKey = (slug) => `s24c_${slug}`;
export const getToken = (slug) => { try { return localStorage.getItem(tokenKey(slug)); } catch { return null; } };
export const setToken = (slug, t) => { try { t ? localStorage.setItem(tokenKey(slug), t) : localStorage.removeItem(tokenKey(slug)); } catch { /* storage blocked */ } };

export function accountApi(slug) {
  const inst = axios.create({ baseURL: `${API}/store/${slug}/account` });
  inst.interceptors.request.use((cfg) => {
    const t = getToken(slug);
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
  });
  inst.interceptors.response.use((r) => r, (err) => {
    if (err.response?.status === 401 && getToken(slug)) {           // expired / revoked session
      setToken(slug, null);
      window.dispatchEvent(new CustomEvent("s24c:logout", { detail: slug }));
    }
    return Promise.reject(err);
  });
  return inst;
}
